import { jsx as _jsx } from "react/jsx-runtime";
import { isValidElement } from 'react';
import { codeToHtml } from './highlighter';
import { HighlightedCodeBlock } from './highlighted-code-block';
function extractCodeString(children) {
    if (typeof children === 'string') {
        return children;
    }
    if (Array.isArray(children)) {
        return children
            .map((child) => extractCodeString(child))
            .filter(Boolean)
            .join('\n');
    }
    if (isValidElement(children) && children.props.children) {
        return extractCodeString(children.props.children);
    }
    return '';
}
export const CodeBlock = async (props) => {
    const { language, children } = props;
    const code = extractCodeString(children);
    const highlightedCode = await codeToHtml({
        code,
        language: language || 'text',
    });
    return _jsx(HighlightedCodeBlock, { code: code, highlightedCode: highlightedCode, ...props });
};
